import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, User } from '../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isLoading, user } = useAuth();
  // Use typed field — is_superuser is the canonical admin flag from fastapi-users
  const isAdmin = Boolean((user as User | null)?.is_superuser);

  if (isLoading) {
    return <div className="loading-screen">Loading MSapling...</div>;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
